"use strict";
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketTransport = exports.WebSocketClient = exports.BrowserWebSocket = void 0;
var browserWebSocket_1 = require("./browserWebSocket");
Object.defineProperty(exports, "BrowserWebSocket", { enumerable: true, get: function () { return browserWebSocket_1.BrowserWebSocket; } });
var browserWebSocketClient_1 = require("./browserWebSocketClient");
Object.defineProperty(exports, "WebSocketClient", { enumerable: true, get: function () { return browserWebSocketClient_1.WebSocketClient; } });
/** @internal */
var webSocketTransport_1 = require("./webSocketTransport");
Object.defineProperty(exports, "WebSocketTransport", { enumerable: true, get: function () { return webSocketTransport_1.WebSocketTransport; } });
//# sourceMappingURL=index-browser.js.map